function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_212",
  "data-name": "Trazado 212",
  d: "M1.989,0H93.482a1.989,1.989,0,0,1,1.989,1.989V65.636a1.989,1.989,0,0,1-1.989,1.989H1.989A1.989,1.989,0,0,1,0,65.636V1.989A1.989,1.989,0,0,1,1.989,0Z",
  transform: "translate(9.945)",
  fill: "#064382"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_207",
  "data-name": "Trazado 207",
  d: "M1274.917,2728.693c-17.6-4.884-35.438-13.412-46.8-27.707a55.547,55.547,0,0,1-7.956-13.406v47.079a2,2,0,0,0,1.99,1.989h91.492a2,2,0,0,0,1.989-1.989A170.7,170.7,0,0,1,1274.917,2728.693Z",
  transform: "translate(-1210.215 -2669.023)",
  fill: "#01033a"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_213",
  "data-name": "Trazado 213",
  d: "M1.989,0H77.57a1.989,1.989,0,0,1,1.989,1.989V49.724a1.989,1.989,0,0,1-1.989,1.989H1.989A1.989,1.989,0,0,1,0,49.724V1.989A1.989,1.989,0,0,1,1.989,0Z",
  transform: "translate(17.901 7.956)",
  fill: "#69a9f7"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_220",
  "data-name": "Grupo 220",
  transform: "translate(17.901 17.901)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_208",
  "data-name": "Trazado 208",
  d: "M1273.823,2759.1c-2.248-1.214-4.435-2.546-6.564-3.978a66.72,66.72,0,0,1-15.2-13.784v25.718a2,2,0,0,0,1.989,1.989h44.812a117.061,117.061,0,0,1-25.041-9.945Z",
  transform: "translate(-1252.063 -2727.274)",
  fill: "#4794fb"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_878",
  "data-name": "Rect\\xE1ngulo 878",
  width: 11.934,
  height: 23.868,
  rx: 2,
  transform: "translate(33.813 7.956)",
  fill: "#e81687"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_879",
  "data-name": "Rect\\xE1ngulo 879",
  width: 11.934,
  height: 15.912,
  rx: 2,
  transform: "translate(17.901 15.912)",
  fill: "#e81687"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_880",
  "data-name": "Rect\\xE1ngulo 880",
  width: 11.934,
  height: 31.824,
  rx: 2,
  transform: "translate(49.724 0)",
  fill: "#e81687"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_209",
  "data-name": "Trazado 209",
  d: "M1353.619,2800.586h-51.713a1.989,1.989,0,1,1,0-3.978h51.713a1.989,1.989,0,1,1,0,3.978Z",
  transform: "translate(-1270.083 -2750.862)",
  fill: "#275ed4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_210",
  "data-name": "Trazado 210",
  d: "M1309.743,2800.586h-7.837a1.989,1.989,0,1,1,0-3.978h1.273c2.128,1.432,4.316,2.765,6.563,3.978Z",
  transform: "translate(-1270.083 -2750.862)",
  fill: "#1a55bd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_214",
  "data-name": "Trazado 214",
  d: "M5.967,0H109.394a5.967,5.967,0,0,1,5.967,5.967v5.967a5.967,5.967,0,0,1-5.967,5.967H5.967A5.967,5.967,0,0,1,0,11.934V5.967A5.967,5.967,0,0,1,5.967,0Z",
  transform: "translate(0 65.636)",
  fill: "#69a9f7"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_211",
  "data-name": "Trazado 211",
  d: "M1365.633,2884.322h-27.845l-5.967-7.956h39.78Z",
  transform: "translate(-1294.03 -2810.729)",
  fill: "#4794fb"
});

var SvgLaptop = function SvgLaptop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_221",
    "data-name": "Grupo 221",
    width: 115.36,
    height: 83.537,
    viewBox: "0 0 115.36 83.537",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLaptop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/laptop.e7a9bad2.svg";
export { ForwardRef as ReactComponent };